import {PAGE_ERROR} from 'common/domain/constants';
import { STATES } from 'common/domain/states';
 
const URL_VAC = '/vacations-absences/my-vacations-mobile';
const URL_FB = '/food-benefit/my-food-benefit';
const URL_LOANS = '/loans/my-creditworthiness';
 
class ErrorPageController {
  constructor($window, $stateParams, $state, entryPoint) {
    'ngInject';
    this.state = $state;
    this.stateParams = $stateParams;
    this.state = $state;
    this.entryPoint = entryPoint;
    this.errorMessage = this.stateParams.errorMessage;
    this.isMobileApp = $window.innerWidth < 1024;
  }
 
  $onInit() {
    if (this.isMobileApp) {
      this.switchColorFloatingButton = true;
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }
 
  shouldRenderErrorMessage() {
    return !!this.errorMessage;
  }
 
  shouldRenderStateClosed() {
    return this.stateParams.stateName === PAGE_ERROR.CLOSED && !this.errorMessage;
  }
 
  shouldRenderClosedToUserWithoutCreditWorthiness() {
    return this.stateParams.stateName === PAGE_ERROR.LOANS_CLOSED_TO_USER_WITHOUT_CREDITWORTHINESS;
  }
 
  shouldRenderDefault() {
    return !(this.shouldRenderErrorMessage() || this.shouldRenderStateClosed() || this.shouldRenderClosedToUserWithoutCreditWorthiness());
  }
 
  goToEntryPoint() {
    this.state.go(this.entryPoint);
    const path = localStorage.getItem('path');
 
    if (this.isMobileApp) {
      if (path === URL_LOANS) {
        this.state.go(STATES.LOANS.LOANS_CATALOG);
      }
    
      if (path === URL_FB) {
        this.state.go(STATES.FOOD_BENEFIT.MY_FOOD_BENEFIT);
      }
    
      if (path === URL_VAC) {
        this.state.go(STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE);
      }
    }
  }
 
  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.GO_TO_START'
      }
    ];
  }
  
  shouldLinkToWageAdvance(){
    return this.stateParams.stateRedirection;
  }
 
  goToLink(){
    this.state.go(STATES.LOANS.WAGE_ADVANCE, {goWageAdvance: true});
  }
 
}
 
export default ErrorPageController;
 


// WEBPACK FOOTER //
// ./client/app/features/errorPage/errorPage.controller.js